import API from "../Utils/API";

export const getAllLeadNotes = (leadId, successCallback) => (dispatch) => {
  dispatch({ type: "GET_LEAD_NOTES_REQUEST" });
  API.get(`/lead_notes?lead_id=${leadId}`)
    .then((response) => {
      dispatch({ type: "GET_LEAD_NOTES_SUCCESS", payload: response?.data });
      successCallback && successCallback(response?.data);
    })
    .catch((error) => {
      dispatch({
        type: "GET_LEAD_NOTES_FAILURE",
        payload: error.response?.data,
      });
    });
};

export const createLeadNotes =
  (data, successCreateLead, failureCreateLead) => (dispatch) => {
    dispatch({ type: "CREATE_LEAD_NOTES_REQUEST", payload: data });
    API.post("/lead_notes", data)
      .then((response) => {
        dispatch({ type: "CREATE_LEAD_NOTES_SUCCESS", payload: response });

        // dispatch(getAllLeads(url));
        const SLA = successCreateLead ? successCreateLead(response) : null;
      })
      .catch((error) => {
        try {
          dispatch({
            type: "CREATE_LEAD_NOTES_FAILURE",
            payload: error.response?.data,
          });

          if (failureCreateLead) {
            failureCreateLead(error.response?.data); 
          }
        } catch {}
      });
  };

// export const getleadtype =
//   (successCreateLead, failureCreateLead) => (dispatch) => {
//     dispatch({ type: "GET_LEAD_TYPES_REQUEST" });
//     API.get("/get_lead_types")
//       .then((response) => {
//         dispatch({ type: "GET_LEAD_TYPES_SUCCESS", payload: response.data });
//       })
//       .catch((error) => {
//         dispatch({
//           type: "GET_LEAD_TYPES_FAILURE",
//           payload: error.response?.data,
//         });
//       });
//   };
// export const updateLead =
//   (data, url, successUpdateLead, failureUpdateLead) => (dispatch) => {
//     dispatch({ type: "UPDATE_LEAD_REQUEST", payload: data });
//     API.put(`/leads/${data.id}`, data)
//       .then((response) => {
//         dispatch({ type: "UPDATE_LEAD_SUCCESS", payload: response });
//         // dispatch(getAllLeads(url));
//         const SLA = successUpdateLead ? successUpdateLead() : null;
//       })
//       .catch((error) => {
//         try {
//           dispatch({
//             type: "UPDATE_LEAD_FAILURE",
//             payload: error.response.data,
//           });

//           const FLA = failureUpdateLead ? failureUpdateLead() : null;
//         } catch {}
//       });
//   };
//         .catch(error => {
//             dispatch({ type: "UPDATE_LEAD_FAILURE", payload: error.response.data })
//             const FCP = failureCallBack ? failureCallBack() : null;
//         })
// }

// export const deleteLead =
//   (lead_id, url, successDeleteLead, failureDeleteLead) => (dispatch) => {
//     dispatch({ type: "DELETE_LEAD_REQUEST" });
//     API.delete(`/leads/${lead_id}`)
//       .then((response) => {
//         dispatch({ type: "DELETE_LEAD_SUCCESS", payload: response });
//         // dispatch(getAllLeads(url));
//         const SLA = successDeleteLead ? successDeleteLead() : null;
//       })
//       .catch((error) => {
//         try {
//           dispatch({
//             type: "DELETE_LEAD_FAILURE",
//             payload: error.response.data,
//           });

//           const FLA = failureDeleteLead ? failureDeleteLead() : null;
//         } catch {}
//       });
//   };
//         .catch(error => {
//             dispatch({ type: "DELETE_LEAD_FAILURE", payload: error.response.data })
//             const FCP = failureCallBack ? failureCallBack() : null;
//         })
// }
